export default [
  {
    title: 'My Orders',
    name: 'my-orders',
    icon: 'ShoppingCartIcon',
    route: 'UserMyOrders',
    tagVariant: 'light-warning',
  },
]